import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const ProfileCard = ({ person, onClick, basePath = "leadership" }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onClick) {
      onClick(person.id);
    } else {
      navigate(`/${basePath}/${person.id}`);
    }
  };

  return (
    <motion.div
      whileHover={{ y: -6 }}
      transition={{ type: "spring", stiffness: 250 }}
      onClick={handleClick}
      className="h-full bg-white rounded-2xl shadow-md hover:shadow-2xl transition-all duration-500 overflow-hidden cursor-pointer border border-gray-100 flex flex-col group"
    >
      {/* Image Section */}
      <div className="h-72 bg-gray-100 overflow-hidden relative">
        <img
          src={person.image}
          alt={person.name}
          className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
        />

        {/* Soft Overlay for Premium Feel */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/20 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition duration-500"></div>
      </div>

      {/* Content Section */}
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-xl font-semibold text-gray-900 tracking-wide">
          {person.name}
        </h3>

        <p className="text-blue-700 font-medium mt-1 text-sm uppercase tracking-wider">
          {person.designation}
        </p>

        {person.shortBio && (
          <p className="text-gray-600 mt-2 text-sm leading-relaxed line-clamp-3">
            {person.shortBio}
          </p>
        )}

        {/* Spacer to push content properly */}
        <div className="flex-grow"></div>

        {/* Subtle View Profile Indicator */}
        <div className="text-sm text-blue-600 font-medium mt-2 transition duration-300">
          View Profile →
        </div>
      </div>
    </motion.div>
  );
};

export default ProfileCard;